// lespark.us
// api.lespark.cn->api3.lespark.us
// h5.lespark.cn->h5.lespark.us

// lestory.cn
// api.lespark.cn->api3.lestory.cn
// h5.lespark.cn->h5.lestory.cn

let goLink = {
  //header.vue
  header: {
    //主播管理后台
    backend: {
      lespark_cn: "/live_start.html",
      lespark_us: "/live_start.html",
      lestory_cn: "/live_start.html"
    },
    //优质主播招募
    invite: {
      lespark_cn: "http://h5.lespark.cn/good_anchor_join",
      lespark_us: "http://h5.lespark.us/good_anchor_join",
      lestory_cn: "http://h5.lestory.cn/good_anchor_join"
    },
    //签约信息录入
    sign: {
      lespark_cn: "http://h5.lespark.cn/sign_anchor_abroad",
      lespark_us: "http://h5.lespark.us/sign_anchor_abroad",
      lestory_cn: "http://h5.lestory.cn/sign_anchor_abroad"
    },
    //提现
    withdraw: {
      lespark_cn: "/withdraw.html",
      lespark_us: "/withdraw.html",
      lestory_cn: "/withdraw.html"
    },
    //工会入驻
    Trade: {
      lespark_cn: "http://h5.lespark.cn/union_registration",
      lespark_us: "http://h5.lespark.us/union_registration",
      lestory_cn: "http://h5.lestory.cn/union_registration"
    },
    //工会管理
    management: {
      lespark_cn: "http://api.lespark.cn/guild/index",
      lespark_us: "http://api3.lespark.us/guild/index",
      lestory_cn: "http://api3.lestory.cn/guild/index"
    },
    //移动端提现
    non_contract_anchor_withdraw:{
      lespark_cn: "http://api.lespark.cn/non_contract_anchor_withdraw",
      lespark_us: "http://api3.lespark.us/non_contract_anchor_withdraw",
      lestory_cn: "http://api3.lestory.cn/non_contract_anchor_withdraw"
    },
    //pc充值页面
    pay:{
      lespark_cn: "api.lespark.cn/paynow_order",
      lespark_us: "api3.lespark.us/paynow_order",
      lestory_cn: "api3.lestory.cn/paynow_order"
    }
  },
  //menu.vue
  menu:{
    rechargeApp:{
      lespark_cn: "http://api.lespark.cn/pay_web_order",
      lespark_us: "http://api3.lespark.us/pay_web_order",
      lestory_cn: "http://api3.lestory.cn/pay_web_order"
    },
    rechargeVip:{
      lespark_cn: "http://api.lespark.cn/pay_web_order?tab=vip",
      lespark_us: "http://api3.lespark.us/pay_web_order?tab=vip",
      lestory_cn: "http://api3.lestory.cn/pay_web_order?tab=vip"
    },
    goBaiHua:{
      lespark_cn: "http://api.lespark.cn/baihua/index?fromPage=pc",
      lespark_us: "http://api3.lespark.us/baihua/index?fromPage=pc",
      lestory_cn: "http://api3.lestory.cn/baihua/index?fromPage=pc"
    },
    wx_buy_diamonds:{
      lespark_cn: "http://wx.lespark.cn/wx/buy_diamonds",
      lespark_us: "http://wx.lespark.us/wx/buy_diamonds",
      lestory_cn: "http://wx.lestory.cn/wx/buy_diamonds"
    }
  },
  //foot.vue
  foot:{
    rule_privacy:{
      lespark_cn: "http://h5.lespark.cn/rule_privacy",
      lespark_us: "http://h5.lespark.us/rule_privacy",
      lestory_cn: "http://h5.lestory.cn/rule_privacy",
    },
    auto_extend_agreement:{
      lespark_cn: "http://h5.lespark.cn/auto_extend_agreement",
      lespark_us: "http://h5.lespark.us/auto_extend_agreement",
      lestory_cn: "http://h5.lestory.cn/auto_extend_agreement",
    }
  },
  //mobileLogin.vue
  mobileLogin:{
    terms:{
      lespark_cn: "http://api.lespark.cn/terms",
      lespark_us: "http://api3.lespark.us/terms",
      lestory_cn: "http://api3.lestory.cn/terms"
    }
  },
  //liveStart.vue
  liveStart:{
    live_rule_one_page:{
      lespark_cn: "http://h5.lespark.cn/live_rule_one_page",
      lespark_us: "http://h5.lespark.us/live_rule_one_page",
      lestory_cn: "http://h5.lestory.cn/live_rule_one_page"
    }
  },
};

function getUrlKey() {
  let key_txt;
  if (window.location.host.includes("lestory.cn")) {
    key_txt = "lestory_cn";
  } else if (window.location.host.includes("lespark.us")) {
    key_txt = "lespark_us";
  } else {
    key_txt = "lestory_cn";
  }
  return key_txt;
}

export default {
  goLink,
  getUrlKey
};



// WEBPACK FOOTER //
// ./src/constans/urlLink.js